const waveformDevices = ["WaterMeter", "FlowieO"]
export default waveformDevices;